import React from 'react';
import { Link } from 'react-router-dom';
import classes from './styles.module.css';
import {
  PRIVACY_POLICY_PAGE,
  TERMS_AND_CONDITIONS_PAGE,
  FAQS_PAGE,
} from '../../constants/route.const';
import Facebook from '../../assets/icons/facebook.svg';
import Instagram from '../../assets/icons/instagram.svg';
import Youtube from '../../assets/icons/youtube.svg';
import Telegram from '../../assets/icons/telegram.svg';
import Twitter from '../../assets/icons/twitter.svg';
import { Box, Flex, Heading, Image } from '@chakra-ui/react';

const SOCIAL_MEDIA_INFO = [
  {
    title: 'Facebook',
    icon: Facebook,
    link: 'https://www.facebook.com/profile.php?id=100074959262484',
  },
  {
    title: 'Instagram',
    icon: Instagram,
    link: 'https://www.instagram.com/sikka_app/',
  },
  {
    title: 'Youtube',
    icon: Youtube,
    link: 'https://www.youtube.com/channel/UCVw9fGdKbRI9NKvjgGfeGsA',
  },
  { title: 'Telegram', icon: Telegram, link: 'https://t.me/+vaT2f1bG-HYyOWI1' },
  { title: 'Twitter', icon: Twitter, link: 'https://twitter.com/sikkaapp' },
];
function Footer() {
  return (
    <Flex as="footer" pr={[0, 0]} className={classes.footer}>
      <div className={classes.links}>
        <Link to={PRIVACY_POLICY_PAGE} className={classes.link} target="_blank">
          Privacy Policy
        </Link>
        <span>|</span>
        <Link
          to={TERMS_AND_CONDITIONS_PAGE}
          className={classes.link}
          target="_blank"
        >
          Terms & Conditions
        </Link>
        <span>|</span>
        <Link to={FAQS_PAGE} className={classes.link}>
          FAQ
        </Link>
      </div>
      <Box className={classes.copyright} opacity={0.5} mt={[4, 0]}>
        Copyright ©{new Date().getFullYear()} pro.chillar.co.in
      </Box>
    </Flex>
  );
}
export default Footer;
